import { render, staticRenderFns } from "./AlertRule.vue?vue&type=template&id=6a572c0c&scoped=true&"
import script from "./AlertRule.vue?vue&type=script&lang=js&"
export * from "./AlertRule.vue?vue&type=script&lang=js&"
import style0 from "./AlertRule.vue?vue&type=style&index=0&id=6a572c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a572c0c",
  null
  
)

export default component.exports